/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Modal_Preview_LabelInputs */



/**
* | output |
* | --- |
* | "Preview:" |
*
* @param {Position_Modal_Preview_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_preview_label = /** @type {((inputs?: Position_Modal_Preview_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Preview_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Apercu :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschau:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Avance:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预览：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレビュー:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्व दर्शन:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização:")
	return /** @type {LocalizedString} */ ("Preview:")
});